import request from '@/utils/request'
import { getCustomsStatusURL } from '@/api/seaExport/file'
import { findCustomerServiceByNameApi } from '@/api/partner/customer'
import { Message } from '@/utils/Message'
import lang from '@/lang'

/**
 *报关预录查询
 * @param CustomerStatusQueryModel
 * @param file
 * @param job
 */
export async function ylQueryClickHandler(CustomerStatusQueryModel, file, job) {
  if (CustomerStatusQueryModel === 0) {
    await findCustomerServiceByName(file, job, 0)
  } else {
    let soNo = ''
    if (job.lob === 'SE') {
      soNo = job.soNo
      if (soNo === '') {
        Message.warning('SONO ' + lang.t('queryJob.CannotBeEmpty'))
        return
      }
    } else if (job.lob === 'AE' || job.lob === 'SI' || job.lob === 'AI') {
      if (file.uuid) {
        soNo = file.fileNo
      }
      if (soNo === '') {
        Message.warning(lang.t('Message.FileNumberCannotBeEmpty'))
        return
      }
    }
    getYLDUrlResult(file)
  }
}
export async function findCustomerServiceByName(file, job, serviceType) {
  if (!file || !job) return
  if (file.customsBroker === 0) {
    Message.warning(lang.t('Message.TheCustomsBrokerCannotBeEmpty'))
    return
  }
  await findCustomerServiceByNameApi(file.customsBroker, serviceType).then(res => {
    findCustomerServiceByNameHandler(file, job, res.data)
  }
  )
}

export function findCustomerServiceByNameHandler(oneFormData, job, serviceName) {
  if (serviceName !== '') {
    // todo
    // var serverUrl:String = ServerConfig.getChannel("my-amf").endpoint;
    let serverUrl = 'http://stage.cargoware.com/' //  'http://localhost:8080/com.walltech.cargo/'//  serverUrl.slice(0, -17)
    serverUrl = serverUrl + serviceName
    const _data = {}
    if (serviceName === 'DeclerationJYDService') {
      _data.sear = oneFormData.fileNo
      _data.declerationId = oneFormData.fileNo
    } else if (serviceName === 'DeclerationYyService') {
      if (job.lob === 'SE') {
        _data.soNo = job.soNo
      } else {
        _data.soNo = job.mbl
      }
    } else {
      _data.DropDownList1 = 'bill_no'
      if (job.lob === 'SE' && job.soNo !== '') {
        _data.TextBox1 = job.soNo
        _data.mbl = job.soNo
      } else {
        _data.TextBox1 = job.mbl
        _data.mbl = job.mbl
      }
    }
    const data = new FormData()
    data.append('sear', _data.sear)
    data.append('declerationId', _data.declerationId)
    data.append('soNo', _data.soNo)
    data.append('DropDownList1', _data.DropDownList1)
    data.append('TextBox1', _data.TextBox1)
    data.append('mbl', _data.mbl)
    return request({
      url: serverUrl,
      target: '_blank',
      config: {
        headers: {
          'Content-Type': 'multipart/form-data; charset=UTF-8'
        }
      },
      method: 'post',
      data
    })
  } else {
    Message.warning(lang.t('Message.NoInformationCanBeQueried'))
    return
  }
}

export function getYLDUrlResult(file) {
  getCustomsStatusURL(file).then(res => getYLDUrlResultHandler(res.data))
}
// 报关单预录查询
export function getYLDUrlResultHandler(data) {
  // const url1 = data['releaseNotice']
  const url = data['customsDeclaration']
  if (!url) {
    Message.warning(lang.t('Message.NoDocumentsDeclaringOrNonSpermWhaleUsers'))
    return
  }
  if (url.indexOf('http://') < 0) {
    Message.info(url)
    return
  }
  // const values = url.split(',')
  window.open(url)
}

// 报关状态查询
export async function stateQueryClickHandler(CustomerStatusQueryModel, oneFormData, job) {
  if (CustomerStatusQueryModel === 0) {
    await findCustomerServiceByName(oneFormData, job, 1)
  } else {
    let soNo = ''
    if (job.lob === 'SE') {
      soNo = job.soNo
    } else if (job.lob === 'AE' || job.lob === 'SI' || job.lob === 'AI') {
      if (oneFormData.uuid) {
        soNo = oneFormData.fileNo
      }
    }
    if (job.lob === 'SE') {
      if (!soNo) {
        Message.warning('SONO ' + lang.t('queryJob.CannotBeEmpty'))
        return false
      }
    } else {
      if (!soNo) {
        Message.warning(lang.t('Message.FileNumberCannotBeEmpty'))
        return false
      }
    }
    return true
  }
  return false
}
